import { j as jsxRuntimeExports } from './jsx-runtime-D2XkDcqR.js';
import * as require$$0 from 'react';

const TikTokTracking = ({ id }) => {
  require$$0.useEffect(() => {
    if (id) {
      const script = document.createElement("script");
      script.async = true;
      script.src = getScriptSrc(id);
      document.head.appendChild(script);
      return () => {
        script.remove();
      };
    }
  }, [id]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    "script",
    {
      dangerouslySetInnerHTML: {
        __html: getScriptInit(id)
      }
    }
  );
};
const getScriptSrc = (id) => `https://analytics.tiktok.com/i18n/pixel/events.js?sdkid=${id}&lib=ttq`;
const getScriptInit = (id) => [
  `window[window.TiktokAnalyticsObject="ttq"]=[]`,
  `ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"]`,
  `ttq.setAndDefer=(t,e)=>{t[e]=(...o)=>{t.push([e,...o])}}`,
  `for(const t of ttq.methods)ttq.setAndDefer(ttq,t)`,
  `ttq.instance=t=>{const e=ttq._i[t]||[];for(const t of ttq.methods)ttq.setAndDefer(e,t);return e}`,
  `ttq.load=(t,e)=>{ttq._i={},ttq._i[t]=[],ttq._i[t]._u="https://analytics.tiktok.com/i18n/pixel/events.js",ttq._t={},ttq._t[t]=Date.now(),ttq._o={},ttq._o[t]=Object(e)}`,
  `ttq.load(${JSON.stringify(id)})`,
  `ttq.page()`
].join(";");

export { TikTokTracking };
